import React, { memo, useCallback } from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    label: string,
    name: string,
    onChange: (name: string, value: any) => void,
    selected: boolean,
    value: any,
};

const Radio: React.FC<Props> = ({ label, name, onChange, selected, value }) => {
    const theme = useTheme();
    const onClick = useCallback(() => {
        onChange(name, value);
    }, [name, onChange, value]);

    const containerStyle = css`
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: left;
    `;

    const radioStyle = css`
        border: 1px solid ${theme.colours.curiousBlue};
        border-radius: 50%;
        height: 20px;
        min-width: 20px;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
        
        &:hover {
            background-color: ${theme.colours.cornflowerBlue2};
        }
    `;

    const styles = {
        label: () => ({
            cursor: 'pointer',
            fontSize: theme.forms.defaults.fontSize,
            fontFamily: theme.forms.defaults.fontFamily,
        }),
        selection: () => ({
            backgroundColor: theme.colours.curiousBlue,
            borderRadius: '50%',
            height: 14,
            width: 14,
        }),
    };

    return (
        <div css={containerStyle} onClick={onClick}>
            <div css={radioStyle}>
                {selected && <div css={styles.selection} />}
            </div>
            <label css={styles.label} className={'option-text'}>{label}</label>
        </div>
    );
};

export default memo(Radio);
